import React from 'react';

import ActionButtons from './ActionButtons';
import EventCalendar from './EventCalendar';
import { useTimelineContextValue } from './functions';
import { TimelineContextProvider } from './TimelineContext';
import { usePrefetchFavoriteIcons } from './useFavoriteIcons';

const DetailsChronologicalMode = () => {
  const value = useTimelineContextValue();
  usePrefetchFavoriteIcons();

  return (
    <TimelineContextProvider value={value}>
      <EventCalendar />
      {/*@ts-ignore*/}
      <ActionButtons />
    </TimelineContextProvider>
  );
};

export default DetailsChronologicalMode;
